
    var riot = require('riot')
    riot.tag2('kf-img', '<div class="kf-image"> <img class="kf-img" ref="imgThumb" onclick="{imgClick}"> <div show="{showLoader}" class="img-loader"></div> </div> <div if="{showModal}" class="container"> <div class="overlay" onclick="{close}"> <span class="kf-img-close" onclick="{close}">&times;</span> </div> <div class="content"> <div class="image-wrap"> <div show="{showFullLoader}" class="img-loader"></div> <img ref="imgFull" show="{showFull}"> </div> </div> </div>', 'kf-img,[data-is="kf-img"]{ display: inline-block; } kf-img .kf-image,[data-is="kf-img"] .kf-image{ width: 150px; text-align: center; } kf-img .kf-image img,[data-is="kf-img"] .kf-image img{ max-width: 100%; } kf-img .container,[data-is="kf-img"] .container{ position: fixed; overflow: auto; overflow-x: hidden; top: 0; right: 0; bottom: 0; left: 0; text-align: center; display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; -webkit-box-pack: center; -ms-flex-pack: center; justify-content: center; -webkit-box-align: center; -ms-flex-align: center; align-items: center; z-index: 99999; } kf-img .overlay,[data-is="kf-img"] .overlay{ position: fixed; display: block; top: 0; bottom: 0; left: 0; right: 0; background-color: black; opacity: 0.6; z-index: 99998; } kf-img .content,[data-is="kf-img"] .content{ display: inline-block; -webkit-box-sizing: border-box; box-sizing: border-box; position: relative; margin-right: auto; margin-left: auto; z-index: 99999; padding: 0px 20px; } kf-img .image-wrap img,[data-is="kf-img"] .image-wrap img{ width: auto; height: auto; max-width: 50vw; max-height: 50vh; background-color: white } kf-img .kf-img-close,[data-is="kf-img"] .kf-img-close{ color: white; cursor: pointer; position: absolute; right: .5rem; top: .4rem; font-size: 28px; font-weight: bold; } kf-img .img-loader,[data-is="kf-img"] .img-loader{ display: inline-block; border: 10px solid #f3f3f3; border-top: 10px solid #2a8af8; border-radius: 50%; width: 100px; height: 100px; -webkit-animation: spin 2s linear infinite; animation: spin 2s linear infinite; z-index: 9999; }', '', function(opts) {
    this.showModal = false;
    this.showThumbLoader = true;
    this.showThumb = false;
    this.showFullLoader = true;
    this.showFull = false;

    this.on('mount', () => {
      if (!opts.riotSrc) {
        return;
      }
      const imgThumb = this.refs.imgThumb;
      imgThumb.addEventListener('load', () => {
        this.update({
          showThumbLoader: false,
          showThumb: true
        });
      });
      imgThumb.src = opts.riotSrc;
    });

    this.imgClick = () => {
      this.update({ showModal: true });
      const imgFull = this.refs.imgFull;
      imgFull.addEventListener('load', () => {
        this.update({
          showFullLoader: false,
          showFull: true
        })
      });
      imgFull.src = opts.riotSrc.replace('_thumb', '');
    };

    this.close = () => {
      this.update({ showModal: false });
    };
});
    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('kf-img')
    }
  }
  